module.exports = __webpack_public_path__ + "static/media/conhecer-bairro-do-imovel.b0b08b09.webp";